<div class="flex flex-col gap-8">
  <div class="flex flex-col gap-2">
    <h2 class="text-2xl font-bold text-gray-12">Où se trouve votre bien ?</h2>
    <p class="text-sm text-gray-11">
      @if (isLocked()) {
        Adresse enregistrée
      } @else {
        * Information obligatoire
      }
    </p>
  </div>

  @if (isLocked()) {
    <!-- Locked Warning Alert -->
    <div
      class="p-4 rounded-2xl bg-amber-a2 border border-amber-a5 text-amber-12 flex items-start gap-3.5 shadow-2xs"
    >
      <div class="p-2 rounded-xl bg-amber-a3 text-amber-11 shrink-0 flex items-center justify-center">
        <mat-icon class="text-lg! w-5! h-5!">lock</mat-icon>
      </div>
      <div class="flex flex-col gap-1">
        <h3 class="text-sm font-bold text-amber-12 m-0 flex items-center gap-2">
          Adresse verrouillée
          <span
            class="text-[10px] uppercase tracking-wider font-extrabold px-2 py-0.5 rounded-full bg-amber-a4 text-amber-12"
          >
            Non modifiable
          </span>
        </h3>
        <p class="text-xs text-amber-11 m-0 leading-relaxed">
          L'adresse de votre bien ne peut plus être modifiée car l'annonce a déjà été initialisée. Pour
          modifier l'adresse, veuillez supprimer ce bien et en créer un nouveau.
        </p>
      </div>
    </div>

    <!-- Locked Address Card -->
    <div class="p-5 rounded-2xl bg-gray-2 border border-gray-6 flex flex-col gap-3">
      <div class="flex items-center justify-between">
        <span class="text-xs font-bold uppercase tracking-wider text-gray-10">Adresse retenue</span>
      </div>
      <div class="flex items-start gap-3">
        <mat-icon class="text-indigo-9 text-xl shrink-0 mt-0.5">location_on</mat-icon>
        <div class="flex flex-col">
          <span class="text-base font-bold text-gray-12">{{
            model().address.label || model().address.street
          }}</span>
          @if (model().address.complement) {
            <span class="text-xs text-gray-10 mt-0.5">Complément : {{ model().address.complement }}</span>
          }
        </div>
      </div>
    </div>
  } @else {
    <!-- Address Search -->
    <aura-address-search-input
      [query]="searchQuery()"
      [suggestions]="suggestions()"
      [isLoading]="isLoading()"
      (searchChange)="onSearchChange($event)"
      (selectedAddress)="selectAddress($event)"
      (cleared)="clearSearch()"
    ></aura-address-search-input>
  }

  <!-- Map Display -->
  @if (model().coordinates.latitude && model().coordinates.longitude) {
    <div class="bg-gray-1 border-gray-6 flex flex-col gap-6 rounded-xl border p-6">
      <div class="flex flex-col gap-2">
        <div class="flex items-center gap-2 text-lg font-bold text-indigo-11">
          <mat-icon>location_on</mat-icon>
          <span>Votre adresse, votre choix</span>
        </div>
        <p class="text-sm text-gray-11">Vous décidez de ce qui apparaît sur votre annonce</p>
      </div>

      <!-- Map Component -->
      <div class="w-full h-64 md:h-72 rounded-xl overflow-hidden bg-gray-2 border border-gray-6">
        <aura-open-street-map
          [lat]="model().coordinates.latitude ?? 0"
          [lng]="model().coordinates.longitude ?? 0"
          [radius]="radius()"
        ></aura-open-street-map>
      </div>

      <div class="border-gray-6 text-gray-11 rounded-lg border p-4 text-center text-sm">
        Le cercle indique la zone approximative de votre bien.
        <strong> L'adresse exacte ne sera pas divulguée publiquement.</strong>
      </div>

      <!-- Geolocation Type Selector Cards -->
      <div class="space-y-3">
        <div class="flex flex-col gap-1">
          <span class="text-sm font-bold text-gray-12">Zone à afficher sur l'annonce</span>
          <p class="text-xs text-gray-11">
            Choisissez le niveau de précision visible publiquement sur votre annonce. L'adresse exacte ne sera
            jamais divulguée.
          </p>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
          @for (option of displayOptions; track option.value) {
            <button
              type="button"
              [disabled]="isLocked()"
              (click)="!isLocked() && setDisplayType(option.value)"
              class="p-4 rounded-xl border text-left transition-all flex flex-col justify-between gap-2 select-none"
              [class]="
                isLocked()
                  ? model().geolocationType === option.value
                    ? 'bg-indigo-a2 border-indigo-8 ring-2 ring-indigo-7/30 shadow-xs cursor-default'
                    : 'bg-gray-1 border-gray-6 opacity-50 cursor-not-allowed'
                  : model().geolocationType === option.value
                    ? 'bg-indigo-a2 border-indigo-8 ring-2 ring-indigo-7/30 shadow-xs cursor-pointer'
                    : 'bg-gray-1 border-gray-6 hover:border-gray-8 hover:bg-gray-2/50 cursor-pointer'
              "
            >
              <div class="flex items-center justify-between w-full">
                <span
                  class="text-sm font-bold"
                  [class]="model().geolocationType === option.value ? 'text-indigo-12' : 'text-gray-12'"
                >
                  {{ option.label }}
                </span>
                <mat-icon
                  class="text-base! w-4! h-4!"
                  [class]="model().geolocationType === option.value ? 'text-indigo-10' : 'text-gray-9'"
                >
                  {{
                    model().geolocationType === option.value
                      ? 'radio_button_checked'
                      : 'radio_button_unchecked'
                  }}
                </mat-icon>
              </div>
              <p class="text-xs text-gray-11 leading-relaxed">
                {{ option.description }}
              </p>
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>
